<script>
	import * as m from '@app/paraglide/messages.js';
	import { insertHistoryAction } from "@app/store/historyStore.svelte.js";
	import { projectState } from "@app/store/projectStore.svelte.js";
	import { eventGroupState } from "@app/store/eventGroupStore.svelte.js";
	import throttle from "just-throttle";

	let event = $derived(eventGroupState[projectState.selected] && eventGroupState[projectState.selected].selected.length > 0 
		? eventGroupState[projectState.selected].events[eventGroupState[projectState.selected].selected[0]] 
		: false);

	const saveToHistory = throttle(
		() => {
			insertHistoryAction({
				name: "update notes", //action name
				eventGroup: projectState.selected,
				snapshots: [
					{
						store: "eventGroupState",
						value: JSON.stringify(eventGroupState),
					},
				],
			});
		},
		250,
		{
			leading: false,
			trailing: true,
		}
	);

	function updateEventProperty(property, value) {
		if (!event) return;
		
		// Update the actual event in the store to ensure reactivity
		const eventIndex = eventGroupState[projectState.selected].selected[0];
		eventGroupState[projectState.selected].events[eventIndex][property] = value;
		
		// No need to manually sync local state as derived will handle it
		saveToHistory();
	}
</script>

<form id="notes-form" aria-label={m.notes_form_aria_label()}>
	<div class="row">
		{#if event}
			<div class="col-auto">
				<label for="notes-input" class="form-label">{m.notes_label()}</label>
				<textarea 
					id="notes-input"
					class="form-control bg-light mb-2" 
					rows="3" 
					value={event.notes || ""}
					disabled={!event} 
					placeholder={m.notes_placeholder()} 
					oninput={(e) => updateEventProperty('notes', e.target.value)}
					aria-label={m.notes_event_aria_label()}
				></textarea>
				<div class="form-check form-switch">
					<input 
						id="notes-status-check" 
						class="form-check-input" 
						type="checkbox" 
						checked={event.notesCheck || false}
						onchange={(e) => updateEventProperty('notesCheck', e.target.checked)}
						aria-label={m.notes_mark_done_aria_label()}
					/>
					<label class="form-check-label" for="notes-status-check">
						{event.notesCheck ? m.notes_done_label() : m.notes_mark_as_done_label()}
					</label>
				</div>
			</div>

			<div class="col">
				<label for="reply-input" class="form-label">{m.notes_reply_label()}</label>
				<textarea 
					id="reply-input"
					class="form-control bg-light mb-2" 
					rows="3" 
					value={event.reply || ""}
					disabled={!event} 
					placeholder={m.notes_reply_placeholder()} 
					oninput={(e) => updateEventProperty('reply', e.target.value)}
					aria-label={m.notes_reply_aria_label()}
				></textarea>
				<div class="form-check form-switch">
					<input 
						id="reply-status-check" 
						class="form-check-input" 
						type="checkbox" 
						checked={event.replyCheck || false}
						onchange={(e) => updateEventProperty('replyCheck', e.target.checked)}
						aria-label={m.notes_reply_mark_done_aria_label()}
					/>
					<label class="form-check-label" for="reply-status-check">
						{event.replyCheck ? m.notes_done_label() : m.notes_mark_as_done_label()}
					</label>
				</div>
			</div>
		{:else}
			<div class="col">
				<label for="disabled-textarea" class="form-label text-muted">{m.notes_no_event_selected_label()}</label>
				<textarea 
					id="disabled-textarea"
					class="form-control bg-light" 
					disabled 
					placeholder={m.notes_select_event_placeholder()}
					aria-label={m.notes_no_event_aria_label()}
				></textarea>
			</div>
		{/if}
	</div>
</form>

<style>
	textarea {
		height: 110px;
		resize: both;
	}

	#notes-input {
		width: 290px;
	}
</style>
